var x, y, top, left, down;

$('#BT5 .BPP .block').mousedown(function (e) {
  e.preventDefault();
  down = true;
  x = e.pageX;
  y = e.pageY;
  top = $(this).scrollTop();
  left = $(this).scrollLeft();
});

$('body').mousemove(function (e) {
  if (down) {
    var newX = e.pageX;
    var newY = e.pageY;

    $('#BT5 .BPP .block').scrollTop(top - newY + y);
    $('#BT5 .BPP .block').scrollLeft(left - newX + x);
  }
});

$('body').mouseup(function (e) {
  down = false;
});

$('.VP .minus').hide();
$('.VP .title').click(function () {
  $(this).parent('div').siblings('.description').slideToggle(500);
  $(this).siblings('.plus').toggle();
  $(this).siblings('.minus').toggle();
});

$('form.BA-product-single__form').submit(function (e) {
  e.preventDefault();
});

$('.ATC .BA-product-single__form button.add-to-cart').on('click', function (e) {
  // e.preventDefault();
  // const variant_id = $(this).siblings(".BA-product-single__variants").children("option:first").val();
  // const status = $(this).attr('status');
  // if(status == "true"){
  //   addSubscriptionItemToCart(variant_id, 1, "4", "Weeks");
  // }else if(status == "false"){
  //   addOneTimePurchaseItemToCart(variant_id);
  // }

  let label = $(this)
    .parent('.BA-product-single__form')
    .parent('.cart')
    .parent('.buy-buttons')
    .siblings('.subs-check')
    .children('.subscription');

  let subscriptionProductID = $(label).attr('subscription-product-id') || '';
  let subscriptionON = $(label).hasClass('checked');

  let currentVariantID = $(this)
    .siblings('.BA-product-single__variants')
    .children('option')
    .attr('current-variant-id');

  console.log(subscriptionProductID);

  let productID;
  if (subscriptionProductID != '' && subscriptionON) {
    productID = subscriptionProductID;
    addSubscriptionItemToCart(productID, 1, '4', 'Weeks');
  } else {
    productID = currentVariantID;
    addOneTimePurchaseItemToCart(productID);
  }

  console.log(productID);
});
$(document).ready(function () {
  $('.sub-price').hide();
});
$('.ATC .subscription .subscription-box').change(function () {
  $(this).parents('label.subscription').toggleClass('checked');
  let OpriceSelector = $(this)
    .parents('label.subscription')
    .parents('.subs-check')
    .siblings('.buy-buttons')
    .children('.price')
    .children('.orignal-price');
  let SpriceSelector = $(this)
    .parents('label.subscription')
    .parents('.subs-check')
    .siblings('.buy-buttons')
    .children('.price')
    .children('.sub-price');
  let price = parseFloat(OpriceSelector.text().trim().substring(1));
  let newPrice = (price * 0.8).toFixed(2);
  SpriceSelector.text('$' + newPrice);
  if ($(this).is(':checked')) {
    $(OpriceSelector).hide();
    $(SpriceSelector).show();
  } else {
    $(OpriceSelector).show();
    $(SpriceSelector).hide();
  }
});

  // let text;
  // $(".cart__items .cart__item").each(function(){
  //   console.log("hide");
  //   text = $(this).children(".cart__item-details").children('.cart__item-title').children(".cart__item-name").text();
  //   console.log(text);
  //   if((text).includes('-Pack')){
  //       $(this).children(".cart__item-details").children(".cart__item-sub").children('div').children(".js-qty__wrapper").hide();
  //   }else{
  //       $(this).children(".cart__item-details").children(".cart__item-sub").children('div').children(".js-qty__wrapper").show();
  //   }
  // });

function addSubscriptionItemToCart(variant_id, qty, frequency, unit_type) {
  data = {
    id: variant_id,
    quantity: qty,
    properties: {
      shipping_interval_frequency: frequency,
      shipping_interval_unit_type: unit_type,
    },
  };
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function (data) {
      console.log(data.id);
      // document.dispatchEvent(new CustomEvent('cart:build'));
      updateCart();
    },
  });
}

function addOneTimePurchaseItemToCart(variant_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variant_id,
    },
    dataType: 'json',
    success: function (data) {
      console.log(data.id);
      // document.dispatchEvent(new CustomEvent('cart:build'));
      updateCart();
    },
  });
}

function updateCart() {
  setTimeout(() => {
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  }, 200);
  //  location.reload();
}


function subscriptionChanged($element){
  
  console.log('Working');
  let OpriceSelector = $element
    .parents('.subscription')
    .parents('.subs-check')
    .siblings('.buy-buttons')
    .children('.price')
    .children('.orignal-price');
  let SpriceSelector = $element
    .parents('.subscription')
    .parents('.subs-check')
    .siblings('.buy-buttons')
    .children('.price')
    .children('.sub-price');
  let price = parseFloat(OpriceSelector.text().trim().substring(1));
  let newPrice = (price * 0.8).toFixed(2);
  SpriceSelector.text('$' + newPrice);
  if ($element.is(':checked')) {
    // $(OpriceSelector).hide();
    $(OpriceSelector).css('text-decoration', 'line-through');
    $(SpriceSelector).show();
  } else {
    // $(OpriceSelector).show();
    $(OpriceSelector).css('text-decoration', 'none');
    $(SpriceSelector).hide();
  }
}

// Best seller
$('.BSS .subs-check .best-seller-subscription-box').change(function () {
  $(this)
    .parent('.subscription')
    .parent('.subs-check')
    .toggleClass('subscriptionEnabled');
  subscriptionChanged($(this));
});

$('.BSS .add-to-cart').click(function () {
  let selectedProtein = $('.BSS #Protein').val();
  let selectedVitamin = $('.BSS #Vitamins').val();
  let selectedValue = selectedProtein + ' / ' + selectedVitamin;
  console.log(selectedValue);

  $('#get_selected_item_id li').each(function () {
    var thisOptionValue = $(this).text();
    let selectedVariantID = null;
    if (thisOptionValue === selectedValue) {
      let subscriptionID = '#subs_' + thisOptionValue.replace(' / ', '-');
      let callSubscriptionID = subscriptionID.replace(/\s/g, '-');
      let getSubscriptionID = callSubscriptionID.replace("'", '');

      let subscriptionEnabled = $(this)
        .parent('#get_selected_item_id')
        .siblings('.subs-check')
        .hasClass('subscriptionEnabled');

      console.log(subscriptionEnabled);
      if (subscriptionEnabled) {
        selectedVariantID = $(getSubscriptionID).attr('subscription_id');
        addSubscriptionItemToCart(selectedVariantID, 1, '4', 'Weeks');
      } else {
        selectedVariantID = $(getSubscriptionID).attr('variant_id');
        console.log(selectedVariantID);
        addOneTimePurchaseItemToCart(selectedVariantID);
      }
    }
  });
});

// Price Picker on Customer top picks
function getCurrentVariantPrice() {
  let selectedProtein = $('.BSS #Protein').val();
  let selectedVitamin = $('.BSS #Vitamins').val();
  let selectedValue = selectedProtein + ' / ' + selectedVitamin;
  let currentVariantPrice;
  $('#get_selected_item_id li').each(function () {
    var thisOptionValue = $(this).text();
    if (thisOptionValue === selectedValue) {
      let subscriptionID = '#subs_' + thisOptionValue.replace(' / ', '-');
      let callSubscriptionID = subscriptionID.replace(/\s/g, '-');
      let getSubscriptionID = callSubscriptionID.replace("'", '');

      currentVariantPrice = $(getSubscriptionID).attr('variant-price');
      $(this)
        .parent('#get_selected_item_id')
        .siblings('.buy-buttons')
        .children('.price')
        .children('.orignal-price')
        .text(currentVariantPrice);

    }
  });
}
getCurrentVariantPrice();
$('.BSS #Protein').change(function () {
  getCurrentVariantPrice();
  subscriptionChanged($('.BSS .subs-check .best-seller-subscription-box'));
});
$('.BSS #Vitamins').change(function () {
  getCurrentVariantPrice();
  subscriptionChanged($('.BSS .subs-check .best-seller-subscription-box'));
});

// Product Template add to cart button
$(document).ready(function () {
  let addToCart = $('.org-add-to-cart button.add-to-cart');
  let addToCartCopy = $('button.add-to-cart-copy');
  // addToCartCopy.html(addToCart.html());
  $(addToCart).hide();
  $(addToCartCopy).on('click', function (e) {
    e.preventDefault();
    $(addToCart).trigger('click');
  });
  // console.log(addToCart);
});

// Vitamins product Form List
$('.vitamins-tag-list').click(function (e) {
  e.preventDefault();
  var checkedVitamins = [];
  $('.vitamins-form-checkbox:checked').each(function () {
    checkedVitamins.push($(this).attr('tag-val'));
  });
  console.log(checkedVitamins);

  let productTag = [];
  $('.product-tag-list .product-tag').each(function () {
    $(this).hide();
    let productID = $(this).attr('data-id');
    let productIDArray = productID.split(",");
    
    for(let j = 0; j < productIDArray.length; j++){
      if(jQuery.inArray(productIDArray[j], checkedVitamins) != -1){
        $(this).show();
      }
      // console.log(productIDArray[0]);
    }
    // value = checkValue(productID, checkedVitamins);
    
  });
});


function checkValue(value,arr){
  var status;
  for(var i=0; i<arr.length; i++){
    var name = arr[i];
    if(name == value){
      status = 'true';
      break;
    }else{
      status = 'false';
    }
  }

  return status;
}

let tagsArray = [];
$(".list-tags .list-item-tag").each(function(){
  if ($.inArray($(this).attr('tag-value'), tagsArray) >= 0) {
  } else {
    tagsArray.push($(this).attr('tag-value'));
  }
});


for(let i=0; i < tagsArray.length; i++ ){
  $(".product-tags-list").append(`
    <div class="col-6 py-1 list-item-tag" tag-value="${tagsArray[i]}">
      <label class="d-flex align-items-start">
        <input type="checkbox" tag-val="${tagsArray[i]}" id="${tagsArray[i]}" class="me-2 mt-2 vitamins-form-checkbox">
        <div class="text">${tagsArray[i]}</div>
      </label>
    </div>
  `);
} 


// Product bundle
$(".product-bundle-options").hide();
$(".rc_radio__autodeliver").click(function(){
  $(".product-bundle-options").hide();
  $(".fake-cart-btn").hide();
  $(".orginal-cart-btn").show();``
});
$(".rc_radio__onetime").click(function(){
  if($(this).is(":checked")){
    $(".product-bundle-options").show();
    $(".fake-cart-btn").show();
    $(".orginal-cart-btn").hide();
  }else{
    $(".product-bundle-options").hide();
  }
});


let packProductID = $(".product-bundle-options .bundle-option:last .radio-button input[type='radio']").attr("product-pack-id");
let selectedQTY = 1;

$(".product-bundle-options .bundle-option .radio-button input[type='radio']").change(function(){
  if($(this).is(":checked")){
    $(".bundle-option").removeClass("selected");
    $(this).parents(".radio-button ").parents(".bundle-option").addClass("selected");

    selectedQTY = $(this).attr("value");

    if(selectedQTY == 2 || selectedQTY == 3){
      $(".product-bundle-options .disclaimer").show();
    }else{
      $(".product-bundle-options .disclaimer").hide();
    }

    $(".fake-cart-btn .js-qty__num").val(selectedQTY);

    packProductID = $(this).attr("product-pack-id");
  }else{
    $(this).parents(".radio-button ").parents(".bundle-option").removeClass("selected");
  }
})

$(".add-to-cart-pack").click(function() {
  addOneTimePurchasePackItemToCart(packProductID, selectedQTY);
  // console.log(packProductID);
  console.log(selectedQTY);
});


function addOneTimePurchasePackItemToCart(variant_id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: variant_id,
    },
    dataType: 'json',
    success: function (data) {
      console.log(data.id);
      // document.dispatchEvent(new CustomEvent('cart:build'));
      updateCart();
    },
  });
}